import React from 'react';
import { portal, Portal } from '../../../../../Configs/general';

import MultiplePaymentGDC from './MultiplePayment.GDC';
import MultiplePaymentGDG from './MultiplePayment.GDG';
import { config } from '../../../../../Configs';

export const UPLOAD_MODE = {
  MULTIPLE: 0,
  INDIVIDUAL: 1
};

export const TAB_PROPS = [
  {
    id: UPLOAD_MODE.MULTIPLE,
    label: 'Carga masiva',
    disabled: config.payments.multiplePaymentDisabled
  },
  {
    id: UPLOAD_MODE.INDIVIDUAL,
    label: 'Carga individual',
    disabled: config.payments.individualPaymentDisabled
  }
];

const MultiplePayment = props => {
  switch (portal) {
    case Portal.Gascaribe:
      return <MultiplePaymentGDC {...props} />;
    case Portal.Gasguajira:
      return <MultiplePaymentGDG {...props} />;
    case Portal.Efigas:
      return <MultiplePaymentGDC {...props} />;
    default:
      return <></>;
  }
};

export default MultiplePayment;
